import { PaymentMethodEnum } from "../utils/enum";
import useCountryConfigHook from "./useCountryConfigHook";

const usePaymentHook = () => {
  const { payments } = useCountryConfigHook();
  const offlinePayments = payments.filter((p) => p.isOfflinePayment);
  const onlinePayments = payments.filter((p) => p.isOnlinePayment);
  const posPayments = payments.filter((p) => p.isPosPayment);
  const mainPayments = payments.filter((p) => p.isMainPayment);
  const kioskPayments = payments.filter((p) => p.isKioskPayment);
  const paymentIds = payments.map((p) => p.value);

  const getPayment = (paymentId: number) => {
    return payments.find((p) => p.value === paymentId);
  };

  const isOnlinePayment = (paymentId: number) => {
    return onlinePayments.some((p) => p.value === paymentId);
  };

  const isOfflinePayment = (paymentId: number) => {
    return paymentId % 2 === 1 && paymentId !== PaymentMethodEnum.SPLIT_PAYMENT;
  };

  return {
    payments,
    paymentIds,
    kioskPayments,
    posPayments,
    offlinePayments,
    onlinePayments,
    mainPayments,
    getPayment,
    isOnlinePayment,
    isOfflinePayment,
  };
};

export default usePaymentHook;
